import { Box, Typography, Chip, Paper } from '@mui/material';
import { History } from '@mui/icons-material';
import moment from 'moment';
import IPeriodic, { EPeriodicStatus } from '../../models/periodic/periodic';
import { getStatusConfig } from './PeriodicStatsOverview';
import { TFunction } from "i18next";
import { useTranslatedTaskName } from '../../utils/taskNameTranslation';

interface RelatedTaskCardProps {
    task: IPeriodic;
    t: TFunction;
}

export const RelatedTaskCard = ({ task, t }: RelatedTaskCardProps) => {
    const cfg = getStatusConfig(task.status, t);
    const translateTaskName = useTranslatedTaskName();
    const localizedTaskName = translateTaskName({ id: task.taskId, name: task.taskName });

    return (
        <Paper
            elevation={0}
            sx={{
                p: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderRadius: 3,
                bgcolor: '#f8f9fa',
                border: '1px solid #f0f0f0',
                transition: '0.2s',
                '&:hover': { bgcolor: '#f1f3f5', borderColor: '#e0e0e0' },
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ p: 1.2, bgcolor: cfg.bg, color: cfg.color, borderRadius: 2, display: 'flex' }}>
                    {cfg.icon}
                </Box>
                <Box>
                    <Typography variant="body1" sx={{ fontWeight: 700, color: '#333' }}>
                        {localizedTaskName || t('info.unnamedTask')}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                        {task.status === EPeriodicStatus.Accepted ? t('status.Accepted') : t('status.Todo')}:{' '}
                        {moment.utc(task.scheduleDate).local().format('LL')}
                    </Typography>
                </Box>
            </Box>
            <Chip
                label={cfg.label}
                size="small"
                sx={{ bgcolor: cfg.bg, color: cfg.color, fontWeight: 800, fontSize: '0.65rem', height: 26 }}
            />
        </Paper>
    );
};